// The prop contract every field component shares.

import PropTypes from 'prop-types';

export const descriptorShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  html_tag: PropTypes.string,
  html_tag_hidden: PropTypes.bool,
  required: PropTypes.bool,
  description: PropTypes.string,
});

export const fieldPropTypes = {
  descriptor: descriptorShape.isRequired,
  label: PropTypes.string.isRequired,
  // Values arrive as strings, objects or headers tuples depending on the field.
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any,
  warningMessage: PropTypes.string,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
};
